
export default {
    setCountries(state, countries) {
        state.countries = countries;
        localStorage.setItem('countries', JSON.stringify(countries))
    },
}
